import ThemeToggle from "@/components/ThemeToggle";
import BottomNavigation from "@/components/BottomNavigation";
import { MobileNavigationProvider } from '@/lib/MobileNavigation/MobileNavigationProvider';
import { NavigationSync } from '@/components/NavigationSync';

export function Header() {
  return (
    <MobileNavigationProvider>
      <NavigationSync />
      <header
        className="bg-primary text-primary-foreground shadow-md"
        data-testid="app-header"
      >
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <h3
              className="text-lg font-bold text-primary-foreground"
              data-testid="header-title"
            >Small Talk Generator</h3>
            <ThemeToggle />
          </div>
        </div>
      </header>
      <BottomNavigation />
    </MobileNavigationProvider>
  );
}

export default Header;
